import Color from "../../../data/Color";
import Flex from "../../../data/Flex";
import Size from "../../../data/Size";
import UIButton from "../../../ui/UIButton";
import UIContainer from "../../../ui/UIContainer";
import UIFlex from "../../../ui/UIFlex";
import UIIcon from "../../../ui/UIIcon";
import UITable, { ITableColumn, ITableSortDirectionType } from "../../../ui/UITable";
import Api from '../../../api/Api';
import { useEffect, useState } from 'react';
import { dispatch, listen, unlisten } from '../../../dispatcher/Dispatcher';
import AppEvent from '../../../events/AppEvent';
import useLoadingState from "../../../hooks/useLoadingState";
import { UILoadingState } from "../../../ui/UILoadingState";
import UITitle from '../../../ui/UITitle';
import { UIForm } from '../../../ui/UIForm';
import UIInput from '../../../ui/UIInput';
import { UILoadingBox } from '../../../ui/UILoadingBox';
import { IUserData, handleSetIUserData } from '../../../data/UserData';
import './UserView.scss';
import ManageUserOverlay from "../../../ui/overlay/ManageUserOverlay";
import ConfirmOverlay from "../../../ui/overlay/ConfirmOverlay";

export interface IUserProps {
    visible:boolean;

}

export interface IUserState{
    PK:string;
    USERNAME:string;
    EMAIL:string;
    PHONE_NUMBER:string;
    USER_ROLE:string;
    PASSWORD?:string;
}

UserView.PATH = "user-view";

export function UserView($props:IUserProps){

    const [loadingState, setLoading, setError, setLoadingState, resetLoadingState] = useLoadingState({loading:true});
    
    const [userData, setUserData] = useState<IUserData[]>([]);

    const defaultUserState:IUserData = {
        PK:"",
        USERNAME:"",
        EMAIL:"",
        PHONE_NUMBER:"",
        USER_ROLE:"",
        PASSWORD:"",
        SECURITY_GROUP_ID:"",
    }    

    const [userState, setUserState] = useState<IUserState>(defaultUserState);

    const loadUserData = () =>{
        setLoadingState({loading:false, error:undefined});
        Api.cdr.getUsers(($success,$result)=>{
            if($success){
                setLoadingState({loading:false, error:undefined});
                
                let userData = handleSetIUserData($result.summary.results);
                setUserData(userData);
            }else{
                setLoadingState({loading:false, error:$result});
            }
        });
    }

    const _refresh = () => {
        loadUserData();
    };

    const selectedUserEMAIL = ($userData:IUserData) => {
        dispatch(AppEvent.VIEW_USER_DETAILS,$userData);
        ManageUserOverlay.show("User Management",{title:"User Management",desc:"Manage User",cancelLabel:"Cancel", saveLabel:"Save", 
        newUser:false, userData:$userData, refresh:_refresh, action:"updateUser"});
    }

    const addNewUser = ()=>{
        ManageUserOverlay.show("User Management",{title:"User Management",desc:"New User",cancelLabel:"Cancel", saveLabel:"Save", 
        newUser:true,userData:defaultUserState, refresh:_refresh, action:"addUser"});
    }

    const manualUserInputChange=($value:string | number | boolean, $name:string)=>{        
        let newState = {...userState}
        newState.EMAIL = $value as string;
        setUserState(newState);
    }

 
    const _onUserLookupAction = ()=>{

        setLoadingState({loading:false, error:undefined});
        let email = userState.EMAIL.trim();  

        Api.cdr.getUsers(($success,$results)=>{
            if($success){
                setLoadingState({loading:false});
                let userDataArray = handleSetIUserData($results.summary.results);
                if(userDataArray.length==0){
                    ConfirmOverlay.show("errorEMAILNotFound",{confirmLabel:"Ok", hideCancel:true, title:"Error", message:"Email " + email + " Not Found"}); 
                }
                else{
                    setUserData(userDataArray);
                }
                
            }else{
                setLoadingState({loading:false, error:$results});
                if(email==""){
                    ConfirmOverlay.show("errorEMAILNotFound",{confirmLabel:"Ok", hideCancel:true, title:"Error", message:"Email Not Found"});
                }   
                
            }
        },{email:email});
    }

    const _onUserDeleteAction = (pk:string)=>{
        Api.cdr.deleteUser(($success,$results)=>{
            if($success){
                if($results && $results.summary){
                    ConfirmOverlay.show("deleteUser",{confirmLabel:"Ok", hideCancel:true, title:"Delete User", message:"User Deleted"});
                    _refresh();
                }
                else{
                    ConfirmOverlay.show("errorDeleteUser",{confirmLabel:"Ok", hideCancel:true, title:"Error", message:"Unable to Delete User."});    
                }
            }else{
                ConfirmOverlay.show("errorDeleteUser",{confirmLabel:"Ok", hideCancel:true, title:"Error", message:"Unable to Delete User."});
            }
        },{pk:pk});
    }


    const _deleteUser=($userData:IUserData)=>{        
        ConfirmOverlay.show("confirmDelete",{
            title:"Confirm Delete",
            message:"Are you sure you want to delete user "  + $userData.EMAIL + "?",
            confirmAction:()=>{
                _onUserDeleteAction($userData.PK);
            },
            confirmLabel:"Delete",
            cancelLabel:"Cancel"
        });
    }

    const _sort=($sortBy:string, $direction:ITableSortDirectionType, $a:any, $b:any):number=>{
        let numRet:number;

        let strA:string = "";
        let strB:string = "";

        switch($sortBy){
            default:
                let dataA:any = $a;
                let dataB:any = $b;
                strA = dataA[$sortBy];
                strB = dataB[$sortBy];
        }

        numRet = UITable.BASIC_SORT($direction,strA,strB);

        return numRet;
    }
   
    useEffect(()=>{
        loadUserData();  
    },[]);


    let arrColumns:ITableColumn[] = [
        {
            dataKey:"action",
            name:"Manage User",
            width:150,     
            dataGetter:($userData)=>{
                return  (
                    <UIButton onClick={()=>{
                        selectedUserEMAIL($userData);
                    }} size={Size.s36} noPadding iconFontSize={Size.s24} icon={UIIcon.MANAGE_USER} isSquare/>


                );
            }       
        },
        {
            dataKey:"USERNAME",
            name:"Name",
            width:200,       
            flexGrow:1,     
        },
        {
            dataKey:"EMAIL",
            name:"Email - User Name",
            width:280,           
            flexGrow:1,          
        },
        {
            dataKey:"PHONE_NUMBER",
            name:"Phone Number",
            width:120,           
            flexGrow:1,          
        },
        {
            dataKey:"USER_ROLE",
            name:"User Role",
            width:200,     
                   
        },
        {
            dataKey:"action",
            name:"Delete",
            width:100,     
            dataGetter:($userData)=>{
                return  (
                    <UIButton onClick={()=>{
                        _deleteUser($userData);
                    }} size={Size.s36} noPadding iconFontSize={Size.s24} icon={UIIcon.DELETE_USER} isSquare/>


                );
            }       
        },
    ];

    return (
        <div className={UserView.PATH+($props.visible?" visible":"")}>
            
            <UITitle flex={{style:{marginBottom:10}}} title="Users"/>
            <div className="divider" ></div>


            <UIFlex flex={{fullWidth:true, style:{marginBottom:20, flexShrink:0}}}>
                <UIButton  onClick={()=>{
                    addNewUser();
                }} dropShadow color={Color.PRIMARY} label="ADD NEW USER"/> 
            </UIFlex>
            <UIForm flex={{style:{gap:20,marginBottom:20}}} >
                <UIInput 
                    className='userEmail' 
                    flex={{style:{borderRight:"0px", borderTopRightRadius:0, borderBottomRightRadius:0}}} 
                    fontSize={Size.s14} 
                    size={Size.s36} 
                    label="Search" 
                    name='email' 
                    value={userState.EMAIL}
                    onChange={manualUserInputChange}
                    valueExtra={
                        (
                            <>
                                {(
                                    <UIButton dropShadow size={Size.s36} disabled={false} fontSize={Size.s20} isSquare icon={UIIcon.SEARCH_LOCATION} onClick={()=>{
                                        _onUserLookupAction();
                                    }}/>
                                )}
                            
                            </>
                        )
                    } 
                > 
                    {loadingState.loading && (
                        <UILoadingBox flex={{style:{marginTop:15}}}/>
                    )}
                </UIInput>

                

            <UIContainer flex={{direction:Flex.COLUMN, style:{flexShrink:0}}} className="userContainer">
                
                <UILoadingState loading={loadingState.loading} error={loadingState.error}>
                    <UITable
                        reflectContentHeightToCSS={true}
                        columns={arrColumns}
                        data={userData}
                        sort={_sort}
                        sortEnabled={true}
                        initSortBy="USERNAME"
                        rowRenderer={($data:any, $columns:JSX.Element, $className:string, $key:string, $index:number)=>{

                            let cnRow:string = "userRow "+$className;
                            return (
                                <div className={cnRow} key={$key+$index}>
                                    {$columns}
                                </div>
                            );
                        }}                    
                    />
                    {userData.length===0 && (
                        <div className="noData">
                            No Results Available
                        </div>
                    )}
                </UILoadingState>
                
            </UIContainer>
            </UIForm>    

        </div>
    );
}
